import { commonRowAndCellClassRules } from '../../../../components/grid/classRules/classRules';
import NamePropertyComparator from '../../../../components/grid/comparators/NamePropertyComparator';
import defaultObjEquals from '../../../../components/grid/columnDefaults/defaultObjEquals';

export const vesselEniHeading = {
    colId: 'eniNumber',
    headerName: 'ENI',
    field: 'vessel.eniNumber',
    editable: false,
    comparator: NamePropertyComparator,
    equals: defaultObjEquals,
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    hide: true,
    suppressMenu: true,
    filter: false,
    width: 120,
};
